<tandem-card>
  <div class="flex flex-col gap-3">
    <div class="flex flex-row w-full justify-center items-center">
      <h1 class="text-2xl">{{goalType}} Goals</h1>
    </div>
    <div class="flex flex-row justify-start items-center gap-2 cursor-pointer" (click)="sortGoal()">
      <p class="text-sm">Sort By Start Date</p>
      <svg *ngIf="currentSort === 'descending'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 cursor-pointer">
        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
      </svg>
      <svg *ngIf="currentSort === 'ascending'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 cursor-pointer">
        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
      </svg>
    </div>

    <!-- Scrollable Goals Container -->
    <div class="max-h-80 overflow-y-auto pr-2">
      <div *ngFor="let goalControl of goalsFormArray.controls; index as i" class="relative flex justify-between w-full">
        <tandem-form-checkbox
          [disabled]="!editable"
          [control]="getControl(goalControl)"
          [controlName]="i.toString()"
          [inputId]="goals[i].id!.toString()"
          (checkboxToggled)="onToggle($event, goals[i])"
          [label]="getLabelForGoal(i)"
          [description]="getDateString(i)"
          [ngClass]="{'text-red': goalIsExpired(i), 'line-through': goals[i].completed}"
        >
        </tandem-form-checkbox>
        <div class="flex flex-row justify-center items-start px-2 md:px-5 gap-2">
          <tandem-icon [icon]="'edit'" [height]="24" [width]="24" color="black" class="cursor-pointer" (click)="onEdit(i)"></tandem-icon>
          <svg *ngIf="editable" (click)="onDelete(i)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 cursor-pointer">
            <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>
      </div>
    </div>

    <div *ngIf="goals.length === 0">
      <h4>No {{goalType}} goals</h4>
    </div>

    <div class="flex flex-row justify-center">
      <tandem-button theme="outline" color="primary" [onClick]="openGoalDialog.bind(this)">
        Add {{goalType}} Goal
      </tandem-button>
    </div>
  </div>
</tandem-card>
